module.exports = require('./helpers/bundle-url').getBundleURL('1G2bZ') + "10.db14b200.jpg" + "?" + Date.now();